// Shared display formatters for the mobile screens.

// Whole shillings everywhere on mobile: "KES 12,000", never cents.
export const formatKes = (amount) =>
    `KES ${amount.toLocaleString('en-KE', { maximumFractionDigits: 0 })}`;

// "6 Days", "1 Day". Units are the API's term_unit_name labels
// (Days/Weeks/Months/Years), so dropping the trailing "s" singularises.
// Desktop prints "1 Days"; mobile deliberately doesn't.
export const formatTerm = (term, unitName) =>
    `${term} ${term === 1 ? unitName.replace(/s$/, '') : unitName}`;

// "1 application", "12 applications".
export const pluralize = (count, noun) =>
    `${count} ${count === 1 ? noun : `${noun}s`}`;

// First letters of the first two words, uppercased: "Aisha Mwangi" → "AM".
export const initialsOf = (name) =>
    name.split(' ').slice(0, 2).map(part => part[0]).join('').toUpperCase();
